import React, { useState, useEffect } from 'react';
import i18next from 'i18next';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import TableContainer from 'components/molecules/MbTable';
import { epApiDetailData } from 'lib/api/sales';
import FilterWrap from 'components/atoms/FilterWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

const useStyles = makeStyles((theme) => ({
  corpInfo: {
    backgroundColor: theme.palette.common.gray,
    color: '#ffffff',
  },
}));

let initialization = false;
let initParam = {};
const EpApiCalculateDetail = ({ location }) => {
  const classes = useStyles();
  const query = queryString.parse(location.search);

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          nonePltfomTpCodeFilter={true}
          noneDisplayFilter={true}
          noneExternalFilter={true}
          displayFilterList={true}
        />
      </FilterWrap>
      <div style={{ marginTop: 20, borderTop: 'solid 1px #ddd' }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell className={classes.corpInfo} align="center">
                {i18next.t('호스팅사')}
              </TableCell>
              <TableCell align="center">{query.hostingName}</TableCell>
              <TableCell className={classes.corpInfo} align="center">
                {i18next.t('대행사')}
              </TableCell>
              <TableCell align="center">{query.pname}</TableCell>
              <TableCell className={classes.corpInfo} align="center">
                {i18next.t('광고주')}
              </TableCell>
              <TableCell align="center">{query.corpName}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={epApiDetailData}
            params={{ ...params, adverId: query.adverId }}
            sort="asc"
            order="STATS_DTTM"
            dense={true}
            hasExcel
            hasTotal
          />
        </>
      )}
    </>
  );
};

export default withRouter(EpApiCalculateDetail);
